<script setup lang="ts">
  import type { PropType } from 'vue'

  import { HLInputOtp } from '@platform-ui/highrise'

  const props = defineProps({
    id: {
      type: String,
      default: undefined,
    },
    fields: {
      type: Number,
      default: 4,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '0',
    },
    size: {
      type: String as PropType<'3xs' | '2xs' | 'xs' | 'sm' | 'md' | 'lg'>,
      default: 'md',
    },
    separatorPosition: {
      type: Number,
      default: undefined,
    },
  })

  const emit = defineEmits<{
    onComplete: [value: { otp: string; state: 'completed' }]
    onChange: [value: string]
  }>()

  defineOptions({ inheritAttrs: false, name: 'CPInputOtp' })
</script>

<template>
  <HLInputOtp
    v-bind="$attrs"
    :id="props.id"
    :fields="props.fields"
    :disabled="props.disabled"
    :placeholder="props.placeholder"
    :size="props.size"
    :separator-position="props.separatorPosition"
    @onComplete="emit('onComplete', $event)"
    @onChange="emit('onChange', $event)"
  />
</template>
